// extracted by mini-css-extract-plugin
module.exports = {"addTopPadding":"Loader_addTopPadding__1fqDN","container":"Loader_container__25fpM","loader":"Loader_loader__2hZcM","spinner":"Loader_spinner__1BGHY","label":"Loader_label__3oM48"};